import {bind} from 'ramda';

export const error = bind(console.error, console);
export const log = bind(console.log, console);
export const info = bind(console.info, console);
export const warn = bind(console.warn, console);
